<template>
  <!-- content -->
  <div
    id="app"
    class=""
  >

  <div id="teacher">

    <div class="teacher-header p-2">
          <div class="teacher-header-section">
            <h3>
              This site will help you create a Computation Template
              <a class="ct-docu-link" href="https://virtualprogramminglab.github.io/documentation/viplab-3.0/computation_template/" title="Go to Documentation for more Info" alt="Documentation" target="_blank"><b-icon-book>Go to Documentation for more Info</b-icon-book></a>
            </h3>
            <b-button id="start-guide" variant="outline-primary" @click="startGuide">Start Guide</b-button>

            <input
                    type="file"
                    ref="upload"
                    style="display: none"
                    @change="uploadCT"
                    accept="application/JSON"
                  />
                  <b-button
                    class="btn mt-2"
                    id="start-guide"
                    variant="outline-primary"
                    @click="$refs.upload.click()"
                    v-tooltip.bottom="'Upload of previously created template'"
                  >
                    Modify existing Template
                    <b-icon icon="upload" aria-hidden="true"></b-icon>
                  </b-button>
          </div>
        </div>

    <div class="main-div pl-4 pr-4">

      <div class="toggle-controls mt-2">
        <div id="toggle-left-components">
          <a v-b-toggle="'components-collapse'" href="#" id="about">
            <div class="toggle-content">
              Toggle Components
            </div>
          </a>
        </div>

        <div id="toggle-right-config">
          <a v-b-toggle="'config-collapse'" href="#" id="about">
            <div class="toggle-content">
              Toggle Configuration
            </div>
          </a>
        </div>
      </div>

      <div class="teacher-section-wrap">
      <div class="group">

        <!-- Components and Preferences -->
        <b-collapse class="select-list" id="components-collapse" visible>
          <b-card no-body>
                <b-tabs card class="files" id="component-selection" content-class="m-2" fill>

                  <!-- Drag-and-Drop Components -->
                  <b-tab
                    title="Components"
                  >

                    <!-- TODO: Add tooltips to the components-->
                    <div v-if="showTemplate">
                      <div class="mb-2">Template:</div>
                      <transition-group name="list" tag="div">
                        <drag v-for="n in componentsFiles" :key="n" class="drag" :data="n">
                          {{n}}
                          <div class="tooltip-icon pl-2">
                            <b-icon-info-circle v-if="n === 'file'" v-tooltip.top-center="'Drop this to the middle-section, if you want to show the user a file or let the user modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'commandline arguments'" v-tooltip.top-center="'Drop this to the middle-section, if you want to let the user set values of commandline arguments.'"></b-icon-info-circle>
                          </div>
                        </drag>
                      </transition-group>
                    </div>
                    <div v-if="showFile">
                      <div class="mb-2">File:</div>
                      <transition-group name="list" tag="div">
                        <drag v-for="n in componentsFiles.concat(componentsFile)" :key="n" class="drag" :data="n">
                          {{n}}
                          <div class="tooltip-icon pl-2">
                            <b-icon-info-circle v-if="n === 'file'" v-tooltip.top-center="'Drop this to the middle-section, if you want to show the user a file or let the user modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'commandline arguments'" v-tooltip.top-center="'Drop this to the middle-section, if you want to let the user set values of commandline arguments.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'part'" v-tooltip.top-center="'Drop this to the middle-section, if you want to add content to a file. You can also split the content of a file in several parts and decide individually for each file, whether the user will be able to see or even modify it.'"></b-icon-info-circle>
                          </div>
                        </drag>
                      </transition-group>
                    </div>
                    <div v-if="showPart && !thereIsTemplate">
                      <div class="mb-2">Part:</div>
                      <transition-group name="list" tag="div">
                        <drag v-for="n in componentsFiles.concat(componentsFile)" :key="n" class="drag" :data="n">
                          {{n}}
                          <div class="tooltip-icon pl-2">
                            <b-icon-info-circle v-if="n === 'file'" v-tooltip.top-center="'Drop this to the middle-section, if you want to show the user a file or let the user modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'part'" v-tooltip.top-center="'Drop this to the middle-section, if you want to add content to a file. You can also split the content of a file in several parts and decide individually for each file, whether the user will be able to see or even modify it.'"></b-icon-info-circle>
                          </div>
                        </drag>
                      </transition-group>
                    </div>
                    <div v-if="showPart && thereIsTemplate">
                      <div class="mb-2">Part:</div>
                      <transition-group name="list" tag="div">
                        <drag v-for="n in componentsFiles.concat(componentsPart).concat(availableGuiTypes)" :key="n" class="drag" :data="n">
                          {{n}}
                          <div class="tooltip-icon pl-2">
                            <b-icon-info-circle v-if="n === 'file'" v-tooltip.top-center="'Drop this to the middle-section, if you want to show the user a file or let the user modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'part'" v-tooltip.top-center="'Drop this to the middle-section, if you want to add content to a file. You can also split the content of a file in several parts and decide individually for each file, whether the user will be able to see or even modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'checkbox'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using a checkox.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'radio'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using a radio-button.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'dropdown'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using a dropdown.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'toggle'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using a toggle-button.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'input_field'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using an input_field.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'editor'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using an editor.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'slider'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a parameter using a slider.'"></b-icon-info-circle>
                          </div>
                        </drag>
                      </transition-group>
                    </div>
                    <div v-if="showCommands">
                      <div class="mb-2">Commandline Arguments:</div>
                      <transition-group name="list" tag="div">
                        <drag v-for="n in componentsFiles.concat(componentsCommand)" :key="n" class="drag" :data="n">
                          {{n}}
                          <div class="tooltip-icon pl-2">
                            <b-icon-info-circle v-if="n === 'file'" v-tooltip.top-center="'Drop this to the middle-section, if you want to show the user a file or let the user modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'part'" v-tooltip.top-center="'Drop this to the middle-section, if you want to add content to a file. You can also split the content of a file in several parts and decide individually for each file, whether the user will be able to see or even modify it.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'checkbox'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a commandline argument using a checkox.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'radio'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a commandline argument using a radio-button.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'dropdown'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a commandline argument using a dropdown.'"></b-icon-info-circle>
                            <b-icon-info-circle v-if="n === 'toggle'" v-tooltip.top-center="'Drop this to the middle-section, if you want the user to be able to modify a commandline argument using a toggle-button.'"></b-icon-info-circle>
                          </div>
                        </drag>
                      </transition-group>
                    </div>
                  </b-tab>

            </b-tabs>
          </b-card>
        </b-collapse>

        <!-- Graphical View of Template -->
        <div class="dnd-window" id="drag-components-here" :key="signifyChange">
          <b-card no-body>
            <b-tabs card class="files" content-class="m-2" fill>

              <!-- Drag-and-Drop Components -->
              <b-tab title="Drop Here">
                <drop class="top-copy" @drop="onFileDrop($event)" :accepts-data="(file) => ((file  === 'file') || (file === 'commandline arguments'))">
                  <div class="template p-2" @click="openWindow($event, 'template', computationTemplate)">

                    <div v-for="(file, index) in computationTemplate.files" :key="file.identifier + '-' + index">
                      <drop class="copy" @drop="onPartDrop($event,file)" :accepts-data="(part) => part  === 'part'">
                        <div class="file p-2" @click="openWindow($event, 'file', file)">

                          <b-row align-v="stretch">
                            <b-col cols="8">
                              File
                            </b-col>
                            <b-col cols="4">
                              <div class="text-right" @click="removeFile($event, file)">
                                <b-icon icon="x-circle" v-tooltip.top-center="'Delete File'"></b-icon>
                              </div>
                            </b-col>
                          </b-row>

                          <!--<div v-for="(part, index) in file.parts" :key="index">-->
                          <drop-list class="part-droplist" v-if="file.parts" :items="file.parts" @insert="onInsert($event, false, file)" @reorder="$event.apply(file.parts)" :accepts-data="(part) => false" :column="true">
                            <template v-slot:item="{item}">
                              <drag class="item part-drag" :key="item.identifier">
                                <drop class="part-border" @drop="onParameterDrop($event, item)" :accepts-data="(param) => ((availableGuiTypes.includes(param))) && item.parameters">
                                  <div class="part p-2" @click="openWindow($event, 'part', item)">

                                    <b-row align-v="stretch" class="mb-2">
                                      <b-col cols="8">
                                        Part
                                      </b-col>
                                      <b-col cols="4">
                                        <div class="text-right" @click="removePart($event, item)">
                                          <b-icon icon="x-circle" v-tooltip.top-center="'Delete Part'"></b-icon>
                                        </div>
                                      </b-col>
                                    </b-row>

                                    <b-card v-if="item.parameters" no-body class="">
                                      <b-card-header header-tag="header" class="p-1" role="tab">
                                        <b-button block v-b-toggle:[paramAccordeon(item.identifier)] variant="info">
                                          Parameters
                                          <b-icon class="when-closed" icon="caret-down-fill"></b-icon>
                                          <b-icon class="when-open" icon="caret-up"></b-icon>
                                        </b-button>
                                      </b-card-header>
                                      <b-collapse :id="item.identifier+'param'" visible accordion="my-accordion-1" role="tabpanel">
                                        <b-card-body>
                                          <drop-list class="param-droplist" v-if="item.parameters" :items="item.parameters" @insert="onInsert($event, true ,item)" @reorder="$event.apply(item.parameters)" :accepts-data="(param) => false" :column="true">
                                            <template v-slot:item="{item}">
                                              <drag class="item param" :key="item.identifier">
                                                <b-container class="param-container p-2" @click="openWindow($event, 'parameter', item)">

                                                  <b-row align-v="stretch">
                                                    <b-col cols="8">
                                                      {{item.metadata.guiType}}
                                                    </b-col>
                                                    <b-col cols="4">
                                                      <div class="text-right" @click="removeParameter($event, item)">
                                                        <b-icon icon="x-circle" v-tooltip.top-center="'Delete Parameter'"></b-icon>
                                                      </div>
                                                    </b-col>
                                                  </b-row>
                                                </b-container>
                                              </drag>
                                            </template>
                                            <template v-slot:feedback="{data}">
                                              <div class="item feedback" :key="data">{{data}}</div>
                                            </template>
                                          </drop-list>
                                        </b-card-body>
                                      </b-collapse>
                                    </b-card>

                                    <b-card no-body class="">
                                      <b-card-header header-tag="header" class="p-1" role="tab">
                                        <b-button block v-b-toggle:[contentAccordeon(item.identifier)] variant="info">
                                          Content
                                          <b-icon class="when-closed" icon="caret-down-fill"></b-icon>
                                          <b-icon class="when-open" icon="caret-up"></b-icon>
                                        </b-button>
                                      </b-card-header>
                                      <b-collapse :id="item.identifier +'content'" visible accordion="my-accordion-2" role="tabpanel">
                                        <b-card-body>
                                          <div class="part-content-field">
                                            <div class="d-flex">
                                              <div class="flex-grow-1">
                                                <label class="mr-2" for="item.content">content: </label>
                                              </div>
                                              <!-- tooltip -->
                                              <div class="tooltip-icon pl-2">
                                                  <b-icon-info-circle v-tooltip.top-center="'Content, that will be base64url-encoded automatically. Can contain Handlebars.js expressions with PARAM_IDs (identifiers) if the access type of this part is template.'"></b-icon-info-circle>
                                              </div>
                                            </div>
                                            <ace-editor-component
                                              :isParameter="false"
                                              :isHandlebar="false"
                                              :readonly="false"
                                              :item='{
                                                "identifier" : "Editor" + item.identifier,
                                                "content" : item.content
                                              }'
                                              v-on:update:item="updateContent(item, $event)"
                                            ></ace-editor-component>
                                          </div>
                                        </b-card-body>
                                      </b-collapse>
                                    </b-card>
                                  </div>
                                </drop>
                              </drag>
                            </template>
                            <template v-slot:feedback="{data}">
                              <div class="item feedback" :key="data">{{data}}</div>
                            </template>
                          </drop-list>
                          <!--</div>-->
                        </div>
                      </drop>
                    </div>

                    <!-- Commandline Parameters -->
                    <div v-if="computationTemplate.parameters">
                      <drop class="copy" @drop="onParameterDrop($event)" :accepts-data="(param) => ((availableGuiTypes.includes(param))) && computationTemplate.parameters">
                        <div class="file p-2" @click="openWindow($event, 'commands', computationTemplate.parameters)">

                          <b-row align-v="stretch">
                            <b-col cols="10">
                              Commandline Arguments
                            </b-col>
                            <b-col cols="2">
                              <div class="text-right" @click="removeCommandlineArgs($event)">
                                <b-icon icon="x-circle" v-tooltip.top-center="'Delete Commandline Arguments'"></b-icon>
                              </div>
                            </b-col>
                          </b-row>

                          <drop-list class="param-droplist" v-if="computationTemplate.parameters" :items="computationTemplate.parameters" @insert="onInsert($event, true, item)" @reorder="$event.apply(computationTemplate.parameters)" :accepts-data="(param) => false" :column="true" :key="uuid()">
                            <template v-slot:item="{item}">
                              <drag class="item param" :key="item.identifier">
                                <b-container class="param-container p-2" @click="openWindow($event, 'parameter', item)">
                                  <b-row align-v="stretch">
                                    <b-col cols="8">
                                      {{item.metadata.guiType}}
                                    </b-col>
                                    <b-col cols="4">
                                      <div class="text-right" @click="removeParameter($event, item, false)">
                                        <b-icon icon="x-circle" v-tooltip.top-center="'Delete Argument'"></b-icon>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-container>
                              </drag>
                            </template>
                            <template v-slot:feedback="{data}">
                              <div class="item feedback" :key="data">{{data}}</div>
                            </template>
                          </drop-list>

                        </div>
                      </drop>
                    </div>
                  </div>
                </drop>
              </b-tab>
              <b-tab title="JSON Preview">
                <pre>{{ computationTemplate }}</pre>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>

        <!-- TODO: Rename labels to make everything understandable -->
        <!-- Components and Preferences -->
        <b-collapse class="select-list" id="config-collapse" visible>
          <b-card no-body>
                <b-tabs card class="files" content-class="m-2" fill>

                  <!-- Configuration -->
                  <b-tab v-if="preferences" title="Configuration" active>
                    <div class="preferences-list">
                      <!-- Template Data -->
                      <div v-if="showTemplate">

                        <!-- Environment -->
                        <div id="run-configuration">

                          <label class="mr-2" for="computationTemplate.environment">Environment: </label>
                          <div class="d-flex form-group">
                            <div class="dropdown flex-grow-1">
                              <select
                                class="form-control"
                                v-model="computationTemplate.environment"
                                @change="addConfig()"
                              >
                                <option disabled=true>C</option>
                                <option disabled=true>C++</option>
                                <option disabled=true>Java</option>
                                <option disabled=true>Matlab</option>
                                <option disabled=true>Octave</option>
                                <option>Container</option>
                                <option disabled=true>DuMuX</option>
                              </select>
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                                <b-icon-info-circle v-tooltip.top-center="'Specifies the environment used for the Computation. It defines language, runtime, libraries and tools.'"></b-icon-info-circle>
                            </div>
                          </div>

                          <!-- Configuration -->
                          <div v-if="typeof computationTemplate.configuration != 'undefined' && computationTemplate.environment != ''" class="border mb-2 p-2">

                            <!-- resources.image -->
                            <div v-if="computationTemplate.environment == 'Container'" id="image">
                              <label class="mr-2">Docker-Image*:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('resources.image', null)" @input="setConfigvModel('resources.image', $event, null)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Location of the image to be executed. Can have one of the following prefixes: name://, file://, id://'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- running.timelimitInSeconds -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Time Limit for Running the Container (in Seconds):</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" :value="getConfigvModel('running.timelimitInSeconds', null)" @input="setConfigvModel('running.timelimitInSeconds', $event, null, true)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'CPU time limit.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- running.commandLineArguments -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Commandline Arguments:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('running.commandLineArguments', null)" @input="setConfigvModel('running.commandLineArguments', $event, null)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'For C, C++, Java: arguments given to main() function; For DuMuX, Container: Additional command line arguments.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- running.entrypoint -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Docker Entrypoint:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('running.entrypoint', null)" @input="setConfigvModel('running.entrypoint', $event, null)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Executable to run inside the Container. For Container: Can contain handlebar template syntax for injecting PARAM_IDs.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- running.intermediateFilesPattern -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">RegEx-Pattern for Intermediate Result Files:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <div class="ml-4 mr-4">
                                    <!-- set how many values the config should have -->
                                    <label for="'running.intermediateFilesPattern-sb-options'">How many Patterns should there be?</label>
                                    <b-form-spinbutton :id="'running.intermediateFilesPattern-sb-options'" placeholder="0" min="0" :value="getNumberofConfigFields('running.intermediateFilesPattern')" class="mb-2" @change="setNumberOfConfigFields('running.intermediateFilesPattern', $event)"></b-form-spinbutton>
                                    <!-- input config-values -->
                                    <div class="border mb-2 p-2" v-for="(field, index) in getNumberofConfigFields('running.intermediateFilesPattern')" :key="'running.intermediateFilesPattern-' + index">
                                      <!-- value -->
                                      <label>Set value(s):</label>
                                      <input type="text" class="form-control" :value="getConfigvModel('running.intermediateFilesPattern', index)" @input="setConfigvModel('running.intermediateFilesPattern', $event, index)">
                                    </div>
                                  </div>
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'If there are result-files, that are generated step by step, the Backend needs to be notified whether a file was written. This is done by using a RegEx-Expression. The Backend searches for those patterns in Stdout, to find files which are ready to be transferred to the Frontend, so that the results can be displayed.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- running.userId -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">User-Id:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('running.userId', null)" @input="setConfigvModel('running.userId', $event, null, true)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'User id of the user that writes files inside the Container.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- resources.volume -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Volume:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('resources.volume', null)" @input="setConfigvModel('resources.volume', $event, null)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Path in the Container where data is placed.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- resources.memory -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Memory:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('resources.memory', null)" @input="setConfigvModel('resources.memory', $event, null)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Memory limit for the Container.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- resources.numCPUs -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Number of CPUs:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('resources.numCPUs', null)" @input="setConfigvModel('resources.numCPUs', $event, null, true)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Number of CPUs for the Container.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- resources.diskSpace -->
                            <div v-if="computationTemplate.environment == 'Container'">
                              <label class="mr-2">Limit of Disk Space:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getConfigvModel('resources.diskSpace', null)" @input="setConfigvModel('resources.diskSpace', $event, null, true)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Disk space limit for the Container.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>

                            <!-- TODO Config Props need to be added if ViPLab supports other environments than Container -->
                          </div>
                        </div>

                        <!-- Metadata -->
                        <div> <!-- v-if="computationTemplate.metadata"> -->
                          <label class="mr-2" for="computationTemplate.metadata">Metadata of Template: </label>
                          <div class="ml-4 mr-4">
                            <!-- display name -->
                            <div>
                              <label class="mr-2">Name of Template:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getvModelTemplateMetadata('displayName')" @input="setvModelTemplateMetadata('displayName', $event)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Name of Computation Template shown in Frontend.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>
                            <!-- description -->
                            <div>
                              <label class="mr-2">Description:</label>
                              <div class="d-flex form-group">
                                <div class="flex-grow-1">
                                  <input type="text" class="form-control" :value="getvModelTemplateMetadata('description')" @input="setvModelTemplateMetadata('description', $event)">
                                </div>
                                <!-- tooltip -->
                                <div class="tooltip-icon pl-2">
                                    <b-icon-info-circle v-tooltip.top-center="'Short description of Computation Template shown in Frontend.'"></b-icon-info-circle>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- output -->
                          <div id="define-output">
                            <label class="mr-2">Configuration of Output: </label>
                            <div class="ml-4 mr-4">
                              <!-- viewer -->
                              <div>
                                <label class="mr-2" for="computationTemplate.metadata.output.viewer">File Types to be shown in Result: </label>
                                <div class="d-flex form-group">
                                  <div class="flex-grow-1">
                                    <div class="dropdown">
                                      <select
                                        class="form-control"
                                        v-model="vModelOutputViewer"
                                        multiple
                                      >
                                        <option>Image</option>
                                        <option>ParaView</option>
                                        <option>CSV</option>
                                        <option>ViPLabGraphics</option>
                                        <option value="">No Special Outputfile Format</option>
                                      </select>
                                    </div>
                                  </div>
                                  <!-- tooltip -->
                                  <div class="tooltip-icon pl-2">
                                      <b-icon-info-circle v-tooltip.top-center="'When given, specific file extension, like .vtu are interpreted by the frontend for displaying results. Otherwise files are only downloadable.'"></b-icon-info-circle>
                                  </div>
                                </div>
                              </div>
                              <!-- ignore files -->
                              <div>
                                <label class="mr-2" for="computationTemplate.metadata.output.ignore.visualization">Ignore files in visualization</label>
                                <div class="d-flex form-group">
                                  <div class="flex-grow-1">
                                    <ul id="visualizationIgnore" v-if="ignoreVisualizationDefined">
                                      <li v-for="item in computationTemplate.metadata.output.ignore.visualization" :key="item">
                                        {{ item }} <b-icon icon="x" @click="removeIgnoreVisualization(item)"></b-icon>
                                      </li>
                                    </ul>
                                    <input type="text" class="form-control" v-model="outputIgnoreVisualization">
                                    <b-button class="btn mb-3" @click="addIgnoreVisualization()" v-tooltip.top-center="'Add Ignore to Visualization'">
                                      <b-icon icon="plus" aria-hidden="true"></b-icon>
                                    </b-button>
                                  </div>
                                </div>
                                <label class="mr-2" for="computationTemplate.metadata.output.ignore.download">Ignore files in download</label>
                                <div class="d-flex form-group">
                                  <div class="flex-grow-1">
                                    <ul id="visualizationIgnore" v-if="ignoreDownloadDefined">
                                      <li v-for="item in computationTemplate.metadata.output.ignore.download" :key="item">
                                        {{ item }} <b-icon icon="x" @click="removeIgnoreDownload(item)"></b-icon>
                                      </li>
                                    </ul>
                                    <input type="text" class="form-control" v-model="outputIgnoreDownload">
                                    <b-button class="btn mb-3" @click="addIgnoreDownload()" v-tooltip.top-center="'Add Ignore to Download'">
                                      <b-icon icon="plus" aria-hidden="true"></b-icon>
                                    </b-button>
                                  </div>
                                </div>
                              </div>
                              <!-- csv -->
                              <div>
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    <label class="mr-2" for="computationTemplate.metadata.output.csv">How should CSVs be displayed? </label>
                                  </div>
                                  <!-- tooltip -->
                                  <div class="tooltip-icon pl-2">
                                      <b-icon-info-circle v-tooltip.top-center="'Use this object to define connected csv-files, if there are intermediate results.'"></b-icon-info-circle>
                                  </div>
                                </div>
                                <b-button class="btn mb-3" @click="addCsvConfig()" v-tooltip.top-center="'Add Config for Group of CSV-Files'">
                                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                                </b-button>
                                <div class="ml-4 mr-4 mb-2" v-if="(typeof computationTemplate.metadata != 'undefined') && (typeof computationTemplate.metadata.output != 'undefined') && (typeof computationTemplate.metadata.output.csv != 'undefined')">
                                  <div class="border p-2 mb-2" v-for="(csvConfig, index) in computationTemplate.metadata.output.csv" :key="'csvConfig-'+index">
                                    <!-- basename -->
                                    <div>
                                      <div class="d-flex">
                                        <div class="flex-grow-1">
                                          <label class="mr-2" :for="csvConfig.basename">Basename to identify connected CSVs: </label>
                                        </div>
                                        <!-- Delete CSV-Config -->
                                        <div class="tooltip-icon pl-2" @click="removeConfig($event, true, csvConfig)">
                                            <b-icon-x-circle v-tooltip.top-center="'Delete CSV-Config.'"></b-icon-x-circle>
                                        </div>
                                      </div>
                                      <div class="d-flex form-group">
                                        <div class="flex-grow-1">
                                          <input type="text" class="form-control" id="csvConfig.basename" v-model="csvConfig.basename">
                                        </div>
                                        <!-- tooltip -->
                                        <div class="tooltip-icon pl-2">
                                            <b-icon-info-circle v-tooltip.top-center="'Basename defines connected files: Path of file begins with basename.'"></b-icon-info-circle>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- xlabel -->
                                    <div>
                                      <label class="mr-2" for="csvConfig.xlabel">Information about X-Axis: </label>
                                      <div class="ml-4 mr-4">
                                        <!-- key -->
                                        <label class="mr-2" for="csvConfig.xlabel.key">Key of X-Axis in CSV: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvConfig.xlabel.key" v-model="csvConfig.xlabel.key">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Key for x-axis given in csv header.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- label -->
                                        <label class="mr-2" for="csvConfig.xlabel.label">Label for X-Axis: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvConfig.xlabel.label" v-model="csvConfig.xlabel.label">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'X-axis label for diagram.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- factor -->
                                        <label class="mr-2" for="csvConfig.xlabel.factor">Factor to multiply Values: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="number" class="form-control" id="csvConfig.xlabel.factor" v-model.number="csvConfig.xlabel.factor">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Multiply x-values with this factor.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- format -->
                                        <label class="mr-2" for="csvConfig.xlabel.format">Format of the Values: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvConfig.xlabel.format" v-model="csvConfig.xlabel.format">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Format the x-axis values according to format string. For information on the avaliable formating take a look at the info given by Plotly (https://github.com/d3/d3-format/blob/main/README.md#locale_format); Example: To format a number to have two decimals, use 0.2f'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- plots -->
                                    <label class="mr-2" for="csvConfig.plots">Information about the Y-Axis: </label>
                                    <div class="d-flex ml-4 mr-4">
                                      <div class="flex-grow-1">
                                        <label class="mr-2" for="csvConfig.plots">Define multiple Plots generated from one CSV: </label>
                                      </div>
                                      <!-- tooltip -->
                                      <div class="tooltip-icon pl-2">
                                          <b-icon-info-circle v-tooltip.top-center="'Define datasets: Provide y-axis labels for y-key given in csv. For each dataset one diagram is rendered in the result.'"></b-icon-info-circle>
                                      </div>
                                    </div>

                                    <div class="ml-4 mr-4">
                                      <b-button class="btn mb-3" @click="addCsvPlot(index)" v-tooltip.top-center="'Add Y-Axis to generate Plot from CSV-Files'">
                                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                                      </b-button>
                                      <div class="border mb-2 p-2" v-for="(csvPlot, plotIndex) in csvConfig.plots" :key="csvConfig.identifier + '-plot-' + plotIndex">
                                        <!-- key -->
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <label class="mr-2" for="csvPlot.key">Key(s) of Y-Axis in CSV: </label>
                                          </div>
                                          <!-- Delete CSV-Config -->
                                          <div class="tooltip-icon pl-2" @click="removePlot($event, csvConfig, csvPlot)">
                                              <b-icon-x-circle v-tooltip.top-center="'Delete CSV-Config.'"></b-icon-x-circle>
                                          </div>
                                        </div>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvPlot.key" v-model="csvPlot.key">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Key(s) for y-axis given in csv header.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- label -->
                                        <label class="mr-2" for="csvPlot.label">Label for Y-Axis: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvPlot.label" v-model="csvPlot.label">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Y-axis label for diagram.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- factor -->
                                        <label class="mr-2" for="csvPlot.factor">Factor to multiply Values: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="number" class="form-control" id="csvPlot.factor" v-model.number="csvPlot.factor">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Multiply y-values with this factor.'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                        <!-- format -->
                                        <label class="mr-2" for="csvPlot.format">Format of the Values: </label>
                                        <div class="d-flex form-group">
                                          <div class="flex-grow-1">
                                            <input type="text" class="form-control" id="csvPlot.format" v-model="csvPlot.format">
                                          </div>
                                          <!-- tooltip -->
                                          <div class="tooltip-icon pl-2">
                                              <b-icon-info-circle v-tooltip.top-center="'Format the y-axis values according to format string. For information on the avaliable formating take a look at the info given by Plotly (https://github.com/d3/d3-format/blob/main/README.md#locale_format); Example: To format a number to have two decimals, use 0.2f'"></b-icon-info-circle>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- vtk -->
                              <div>
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    <label class="mr-2" for="computationTemplate.metadata.output.vtk">How should VTKs be displayed? </label>
                                  </div>
                                  <!-- tooltip -->
                                  <div class="tooltip-icon pl-2">
                                      <b-icon-info-circle v-tooltip.top-center="'Details for displaying vtk-files.'"></b-icon-info-circle>
                                  </div>
                                </div>
                                <b-button class="btn mb-3" @click="addVtkConfig()" v-tooltip.top-center="'Add Config for Group of VTK-Files'">
                                  <b-icon icon="plus" aria-hidden="true"></b-icon>
                                </b-button>
                                <div class="ml-4 mr-4" v-if="(typeof computationTemplate.metadata != 'undefined') && (typeof computationTemplate.metadata.output != 'undefined') && (typeof computationTemplate.metadata.output.vtk != 'undefined')">
                                  <div class="border mb-2 p-2" v-for="vtkConfig in computationTemplate.metadata.output.vtk" :key="vtkConfig.identifier">
                                    <!-- basename -->
                                    <div>
                                      <div class="d-flex">
                                        <div class="flex-grow-1">
                                          <label class="mr-2" for="vtkConfig.basename">Basename to identify connected VTKs: </label>
                                        </div>
                                        <!-- Delete VTK-Config -->
                                        <div class="tooltip-icon pl-2" @click="removeConfig($event, false, vtkConfig)">
                                            <b-icon-x-circle v-tooltip.top-center="'Delete VTK-Config.'"></b-icon-x-circle>
                                        </div>
                                      </div>
                                      <div class="d-flex">
                                        <div class="flex-grow-1">
                                          <input type="text" class="form-control" id="vtkConfig.basename" v-model="vtkConfig.basename">
                                        </div>
                                        <!-- tooltip -->
                                        <div class="tooltip-icon pl-2">
                                            <b-icon-info-circle v-tooltip.top-center="'Basename defines connected files: Path of file begins with basename.'"></b-icon-info-circle>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Files Data -->
                      <div v-else-if="showFile">
                        <!-- path -->
                        <div>
                          <label class="mr-2" for="selectedFile.path">Path to File: </label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedFile.path" v-model="vModelFilePath">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Relative path to file. It is not allowed to start with /. The path is relative to the path you entered in the configurtion under resources.volume.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                        <!-- metadata syntaxHighlighting -->
                        <div>
                          <label class="mr-2">Syntax Highlighting for File-Content:</label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedFile.syntaxHighlighting"
                               v-model="vModelFileMetadataSyntaxHighlighting">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Mode of the ace editor. List can be found on github (https://github.com/ajaxorg/ace/tree/master/src/mode). Examples: ini, c_cpp, matlab, java.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                        <div>  <!-- description -->
                          <label class="mr-2">Description:</label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedFile.description"
                               v-model="vModelFileMetadataDescription">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Additional information about the file, e.g. what it is used for. It is shown in the Frontend as tooltip behind the filename.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Part Data -->
                      <div v-else-if="showPart">
                        <!-- access -->
                        <div>
                          <label class="mr-2" for="selectedPart.access">Define Access Level: </label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <div class="dropdown">
                                <select
                                  class="form-control"
                                  v-model="vModelPartAccess"
                                  @change="addOrRemoveParameters(selectedPart)"
                                >
                                  <option disabled value="">Choose one of the options below</option>
                                  <option>invisible</option>
                                  <option>visible</option>
                                  <option>modifiable</option>
                                  <option>template</option>
                                </select>
                              </div>
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Defines the access level of this part for the user.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                        <!-- metadata -->
                        <div>
                          <label class="mr-2">Additional Description of Part:</label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedPart.metadata.description" v-model="vModelPartMetadataName">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Additional description of this part to be shown in the Frontend.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Show Parameter Preferences -->
                      <div v-else-if="showParameter">

                        <!-- identifier -->
                        <div>
                          <label class="mr-2" for="selectedParameter.identifier">Identifier for Handlebars.js-Template: </label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedParameter.identifier" v-model="vModelParameterIdentifier">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Unique id for this parameter. This id must be valid Handlebars.js template variable. Example: __BINARY__.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                        <!-- name -->
                        <div>
                          <label class="mr-2" for="selectedParameter.metadata.name">Name: </label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedParameter.metadata.name" v-model="vModelParameterMetadataName">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Label for the parameter to be shown in Frontend.'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>
                        <!-- description -->
                        <div>
                          <label class="mr-2" for="selectedParameter.metadata.description">Description: </label>
                          <div class="d-flex form-group">
                            <div class="flex-grow-1">
                              <input type="text" class="form-control" id="selectedParameter.metadata.description" v-model="vModelParameterMetadataDescription">
                            </div>
                            <!-- tooltip -->
                            <div class="tooltip-icon pl-2">
                              <b-icon-info-circle v-tooltip.top-center="'Description of the parameter. Will be shown in the Frontend as tooltip (just like this one you are hovering over).'"></b-icon-info-circle>
                            </div>
                          </div>
                        </div>

                        <!-- input_field -->
                        <div v-if="selectedParameter.metadata.guiType=='input_field'">
                          <!-- type -->
                          <div>
                            <label class="mr-2" for="selectedParameter.metadata.type">Field Type: </label>
                            <div class="dropdown form-group">
                              <select
                                class="form-control"
                                v-model="selectedParameter.metadata.type"
                                @change="adjustInputType(selectedParameter)"
                              >
                                <option>number</option>
                                <option>text</option>
                              </select>
                            </div>
                          </div>
                          <div v-if="selectedParameter.metadata.type">
                            <!-- default value -->
                            <div>
                              <label class="mr-2" for="selectedParameter.default">Default Value: </label>
                              <input v-if="selectedParameter.metadata.type == 'text'" type="text" class="form-control form-group" id="selectedParameter.default" v-model="vModelInputFieldText">
                              <input v-else class="form-control form-group" id="selectedParameter.default" v-model="vModelInputFieldNumber">
                            </div>
                            <!-- type: number - min, max, step -->
                            <div v-if="selectedParameter.metadata.type == 'number'">
                              <div>
                                <label class="mr-2" for="selectedParameter.min">Minium Value: </label>
                                <input type="number" class="form-control form-group" id="selectedParameter.min" v-model.number="selectedParameter.min">
                              </div>
                              <div>
                                <label class="mr-2" for="selectedParameter.max">Maximum Value: </label>
                                <input type="number" class="form-control form-group" id="selectedParameter.max" v-model.number="selectedParameter.max">
                              </div>
                              <div>
                                <label class="mr-2" for="selectedParameter.step">Step Size: </label>
                                <input type="number" class="form-control form-group" id="selectedParameter.step" v-model.number="selectedParameter.step">
                              </div>
                            </div>
                            <!-- type: text - maxlength -->
                            <div v-if="selectedParameter.metadata.type == 'text'">
                              <div>
                                <label class="mr-2" for="selectedParameter.maxlength">Maximum Text Length: </label>
                                <input class="form-control form-group" id="selectedParameter.maxlength" v-model="vModelParameterMaxlength">
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- slider -->
                        <div v-if="selectedParameter.metadata.guiType=='slider'">
                          <!-- vertical -->
                          <label class="mr-2" for="selectedParameter.metadata.vertical">How should the Slider be displayed? </label>
                          <div class="radiobutton form-check custom-control custom-radio form-group">
                            <div>
                              <input class="form-check-input custom-control-input" id="vertical" type="radio" name="slider-vertical" value=true v-model="selectedParameter.metadata.vertical" />
                              <label class="form-check-label custom-control-label" for="vertical">vertical</label><br>
                            </div>
                            <div>
                              <input class="form-check-input custom-control-input" id="horizontal" type="radio" name="slider-vertical" value=false v-model="selectedParameter.metadata.vertical" checked />
                              <label class="form-check-label custom-control-label" for="horizontal">horizontal</label><br>
                            </div>
                          </div>

                          <!-- default -->
                          <div class="">
                            <label class="mr-2" for="selectedParameter.default">value(s): </label>
                            <div class="ml-4 mr-4 form-group">
                              <!-- set how many values the slider should have -->
                              <label for="selectedParameter.identifier + 'sb-default'">How many values should the slider have?</label>
                              <b-form-spinbutton :id="selectedParameter.identifier + 'sb-default'" placeholder="1" :value="getNumberOfFields(selectedParameter.identifier)" class="form-group" @change="setNumberOfFields(selectedParameter.identifier, $event)"></b-form-spinbutton>
                              <!-- input slider default-values -->
                              <div class="border mb-2 p-2" v-for="(field, index) in getNumberOfFields(selectedParameter.identifier)" :key="selectedParameter.identifier + '-' + index">
                                <label>Set default values for slider-value:</label>
                                <input type="number" class="form-control" id="selectedParameter.default" :value="getSlidervModel(index)" @input="setSlidervModel($event, index)">
                              </div>
                            </div>
                          </div>
                          <!-- min -->
                          <div>
                            <label class="mr-2" for="selectedParameter.min">Minimum Value: </label>
                            <input type="number" class="form-control form-group" id="selectedParameter.min" v-model.number="selectedParameter.min">
                          </div>
                          <!-- max -->
                          <div>
                            <label class="mr-2" for="selectedParameter.max">Maximum Value: </label>
                            <input type="number" class="form-control form-group" id="selectedParameter.max" v-model.number="selectedParameter.max">
                          </div>
                          <!-- step -->
                          <div>
                            <label class="mr-2" for="selectedParameter.step">Step Size: </label>
                            <input type="number" class="form-control form-group" id="selectedParameter.step" v-model.number="selectedParameter.step">
                          </div>
                        </div>

                        <!-- editor -->
                        <div class="form-group" v-if="selectedParameter.metadata.guiType=='editor'">
                          <div>
                            <label class="mr-2" for="selectedParameter.default">Value: </label>
                            <ace-editor-component
                              :isParameter="false"
                              :isHandlebar="false"
                              :readonly="false"
                              :item='{
                                "identifier" : "Editor" + selectedParameter.identifier,
                                "content" : selectedParameter.default[0]
                              }'
                              v-on:update:item="setEditorValue($event)"
                            ></ace-editor-component>
                          </div>
                        </div>

                        <!-- checkbox, dropdown, toggle, radio -->
                        <div v-if="selectedParameter.metadata.guiType=='checkbox' || selectedParameter.metadata.guiType=='dropdown' || selectedParameter.metadata.guiType=='toggle'|| selectedParameter.metadata.guiType=='radio'">
                          <!-- options -->
                          <div>
                            <label class="mr-2" for="selectedParameter.options">Value(s): </label>
                            <div class="ml-4 mr-4">
                              <!-- set how many values the checkbox should have -->
                              <label for="selectedParameter.identifier + 'sb-options'">How many values should the parameter have?</label>
                              <b-form-spinbutton :id="selectedParameter.identifier + 'sb-options'" placeholder="1" :value="getNumberOfFields(selectedParameter.identifier)" class="form-group" @change="setNumberOfFields(selectedParameter.identifier, $event)"></b-form-spinbutton>

                              <!-- input option-values -->
                              <div class="border form-group p-2" v-for="(field, index) in getNumberOfFields(selectedParameter.identifier)" :key="selectedParameter.identifier + '-' + index">
                                <!-- value -->
                                <label>Set value:</label>
                                <input type="text" class="form-control form-group" id="field.value" :value="getFixedParamvModel(index)" @input="setFixedParamvModel($event, index, 'value')">
                                <!-- text -->
                                <label>Set label for value (else value is used):</label>
                                <input type="text" class="form-control form-group" id="field.text" :value="getFixedParamvModel(index, 'text')" @input="setFixedParamvModel($event, index, 'text')">
                                <!-- selected - radio -->
                                <label class="mr-2">Is selected? </label>
                                <div v-if="selectedParameter.metadata.guiType=='radio'" class="radiobutton form-check custom-control custom-radio form-group">
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+ '-'+'selected'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-selected'" :value=true @input="setFixedParamvModel($event, index, 'selected')" :checked="getRadioSelected(index) ? true : false" />
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+ '-'+'selected'">selected</label><br>
                                  </div>
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+ '-'+'unselected'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-selected'" :value=false @input="setFixedParamvModel($event, index, 'selected')" :checked="getRadioSelected(index) ? false : true" />
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+ '-'+'unselected'">not selected</label><br>
                                  </div>
                                </div>
                                <!-- selected checkbox, dropdown, toggle -->
                                <div v-else class="radiobutton form-check custom-control custom-radio form-group">
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+ '-'+'selected'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-selected'" :value=true @input="setFixedParamvModel($event, index, 'selected')" :checked="getFixedParamvModel(index, 'selected')? true : false"/>
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+ '-'+'selected'">selected</label><br>
                                  </div>
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+ '-'+'unselected'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-selected'" :value=false @input="setFixedParamvModel($event, index, 'selected')" :checked="getFixedParamvModel(index,'selected')? false : true" />
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+ '-'+'unselected'">not selected</label><br>
                                  </div>
                                </div>
                                <!-- disabled -->
                                <label class="mr-2">Is disabled? </label>
                                <div class="radiobutton form-check custom-control custom-radio">
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+'-'+'disabled'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-disabled'" :value=true @input="setFixedParamvModel($event, index, 'disabled')" :checked="getFixedParamvModel(index,'disabled')? true : false"/>
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+'-'+'disabled'">disabled</label><br>
                                  </div>
                                  <div>
                                    <input class="form-check-input custom-control-input" :id="selectedParameter.identifier+'-'+index+'-'+'enabled'" type="radio" :name="selectedParameter.identifier+'-'+index+'-'+'checkbox-disabled'" :value=false @input="setFixedParamvModel($event, index, 'disabled')" :checked="getFixedParamvModel(index,'disabled')? false : true" />
                                    <label class="form-check-label custom-control-label" :for="selectedParameter.identifier+'-'+index+'-'+'enabled'">enabled</label><br>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Validation -->
                        <div>
                          <label class="mr-2" for="selectedParameter.validation">Validation: </label>

                          <!-- mode: any -->
                          <div v-if="selectedParameter.mode === 'any'">

                            <div class="d-flex form-group">
                              <div class="flex-grow-1">
                                <div class="dropdown">
                                  <select
                                    class="form-control"
                                    v-model="selectedParameter.validation"
                                    @change="adjustPatternExistence(selectedParameter)"
                                  >
                                    <option value="pattern">Set a RegEx-Pattern the text-value has to fulfill</option>
                                    <option value="range">Set Range for the value</option>
                                    <option value="none" selected="selected">Any value is allowed</option>
                                  </select>
                                </div>
                              </div>
                              <!-- tooltip -->
                              <div class="tooltip-icon pl-2">
                                <b-icon-info-circle v-tooltip.top-center="'Set if and how the parameter should be validated.'"></b-icon-info-circle>
                              </div>
                            </div>

                            <!-- pattern -->
                            <div class="ml-4 mr-4" v-if="selectedParameter.validation === 'pattern'">
                              <label class="mr-2" for="selectedParameter.pattern">RegEx-Pattern for Validation: </label>
                              <input type="text" class="form-control" id="selectedParameter.pattern" v-model="selectedParameter.pattern">
                            </div>

                          </div>

                          <!-- mode: fixed -->
                          <div v-else>
                            <div class="d-flex form-group">
                              <div class="flex-grow-1">
                                <div class="dropdown">
                                  <select
                                    class="form-control"
                                    v-model="selectedParameter.validation"
                                  >
                                    <option value="oneof">Only one option selectable</option>
                                    <option value="minone">Set at min one value</option>
                                    <option value="anyof" selected="selected">Any value is allowed</option>
                                  </select>
                                </div>
                              </div>
                              <!-- tooltip -->
                              <div class="tooltip-icon pl-2">
                                <b-icon-info-circle v-tooltip.top-center="'Set if and how the parameter should be validated.'"></b-icon-info-circle>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-collapse>
        </div>
        <div class="validation-div pl-2 pr-2 pb-2">
          <b-button @click="validateJson">Validate</b-button>
          <div class="validation-result-div">

            <b-card v-if="validationRunning" class="p-2">
              <b-skeleton animation="wave" width="85%"></b-skeleton>
              <b-skeleton animation="wave" width="55%"></b-skeleton>
              <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
            <b-card :class="classValidity" class="p-2" v-if="!validationRunning && (validationArgsResult != null || validationPartParameterResult != null || validationResult != null)">
              <pre>{{validationResult}}</pre>
              <pre v-if="validationPartParameterResult != null">{{validationPartParameterResult}}</pre>
              <pre v-if="validationArgsResult != null">{{validationArgsResult}}</pre>
            </b-card>

          </div>
        </div>
        <div class="p-2" v-if="isLoggedIn">
          <b-button
            variant="success"
            @click="runTemplate"
            :disabled="validateJson? false : true">
            Execute Template
            <b-icon icon="play" aria-hidden="true"></b-icon>
          </b-button>
          <div id="iframe-div"></div>
        </div>
        <div class="pl-2 pr-2 pb-2">
          <b-button
            @click="downloadCT"
            v-tooltip.top-center="'Download Computation Template'">
            Download Computation Template
            <b-icon
              icon="download"
              aria-hidden="true"
            ></b-icon>
          </b-button>
        </div>
      </div>
    </div>
    <v-tour name="myTour" :steps="steps" :options="{ highlight: true }"></v-tour>
  </div>
  </div>
</template>

<script>
import { Drag, Drop, DropList } from 'vue-easy-dnd';

// import Ace
import base64url from 'base64url';
import Ajv from 'ajv';
import AceEditorComponent from '../../components/EditorComponent-Ace.vue';

// for validation
import ctSchema from './json-schema/computation-template-container.json';
import parameterSchema from './json-schema/parameters.json';
import commandlineArgumentsSchema from './json-schema/commandline-arguments.json';

export default {
  name: 'app',
  components: {
    Drag,
    Drop,
    DropList,
    AceEditorComponent,
  },
  data() {
    return {
      componentsFiles: ['file', 'commandline arguments'],
      componentsFile: ['part'],
      componentsPart: ['part'],
      componentsCommand: ['checkbox', 'radio', 'dropdown', 'toggle'],
      availableGuiTypes: ['input_field', 'editor', 'slider', 'checkbox', 'radio', 'dropdown', 'toggle'],
      preferences: true,
      selectedParameter: {},
      selectedPart: {},
      selectedFile: {},
      showTemplate: true,
      showFile: false,
      showPart: false,
      showParameter: false,
      showCommands: false,
      valueNumbers: new Map(),
      schema: ctSchema,
      paramSchema: parameterSchema,
      commandlineArgsSchema: commandlineArgumentsSchema,
      validationResult: null,
      validationPartParameterResult: null,
      validationArgsResult: null,
      steps: [
        {
          target: '#start-guide',
          content: 'Tour the <strong>ViPLab Computation Template Generator</strong>!',
        },
        {
          target: '#run-configuration',
          content: 'Choose the Environment! How is your Application run? After that, configure other parameters for the execution.',
          offset: -200,
        },
        {
          target: '#component-selection',
          content: 'Add components, like files, parts of files and gui-elements to your template by dragging and dropping them to the middle-section.',
        },
        {
          target: '#component-selection',
          content: 'For example: Drag-and-drop a file to add an input-file, or display code-snippets to the user.',
        },
        {
          target: '#component-selection',
          content: 'Additionally, if you want the user to modify the commandline arguments for execution, you can drag-and-drop the commandline argument-element. Then add GUI-elements to specify possible values the user can select from.',
        },
        {
          target: '#drag-components-here',
          content: 'By clicking on the different components in the middle-section, you can modify the configuration of each component on the right/bottom.',
          offset: -200,
          params: {
            placement: 'top',
          },
        },
        {
          target: '#define-output',
          content: 'Last, define, what the output should look like.',
          offset: -200,
          params: {
            placement: 'top',
          },
        },
      ],
      validationRunning: false,
      classValidity: '',
      signifyChange: true,
      outputIgnoreVisualization: '',
      outputIgnoreDownload: '',
    };
  },
  computed: {
    json: {
      get() {
        this.$forceUpdate();
        return this.$store.state.jsonTemplate;
      },
      set(newValue) {
        this.$store.commit('updateJsonTemplate', newValue);
        this.$forceUpdate();
      },
    },
    token: {
      get() {
        this.$forceUpdate();
        return this.$store.state.token;
      },
      set(newValue) {
        this.$store.commit('updateToken', newValue);
      },
    },
    ws: {
      get() {
        this.$forceUpdate();
        return this.$store.state.ws;
      },
      set(newValue) {
        this.$store.commit('updateWebSocket', newValue);
      },
    },
    computationTemplate: {
      get() {
        this.$forceUpdate();
        return this.$store.state.generatedComputationTemplate;
      },
      set(newValue) {
        this.$store.commit('updateGeneratedComputationTemplate', newValue);
      },
    },
    modifiedByTeacher: {
      get() {
        return this.$store.state.modifiedByTeacher;
      },
      set(newValue) {
        this.$store.commit('updateModifiedByTeacher', newValue);
      },
    },
    thereIsTemplate() {
      return Object.values(this.computationTemplate.files).find(
        (file) => Object.values(file.parts).find((part) => part.access === 'template'),
      );
    },
    vModelInputFieldText: {
      get() {
        if (this.selectedParameter.default.length > 0) {
          return base64url.decode(this.selectedParameter.default[0]);
        }
        return '';
      },
      set(val) {
        if (typeof this.selectedParameter !== 'undefined') {
          this.$set(this.selectedParameter.default, 0, base64url(val));
          this.$forceUpdate();
        }
      },
    },
    vModelInputFieldNumber: {
      get() {
        if (this.selectedParameter.default.length > 0) {
          return this.selectedParameter.default[0];
        }
        return '';
      },
      set(val) {
        let newValue = parseFloat(val);

        if (Number.isNaN(newValue)) {
          // set to old value, if input was not null
          if (typeof this.selectedParameter !== 'undefined' && val !== '') {
            [newValue] = this.selectedParameter.default;
          // set to old value if new char was string not number
          } else if (typeof this.selectedParameter !== 'undefined' && val.length > 0) {
            [newValue] = this.selectedParameter.default;
          // else set value to null
          } else {
            newValue = null;
          }
        }

        if (typeof this.selectedParameter !== 'undefined') {
          this.$set(this.selectedParameter.default, 0, newValue);
        }

        if (newValue == null) {
          this.$delete(this.selectedParameter.default, 0);
        }
        this.$forceUpdate();
      },
    },
    vModelOutputViewer: {
      get() {
        if (typeof this.computationTemplate.metadata !== 'undefined') {
          if (typeof this.computationTemplate.metadata.output !== 'undefined') {
            if (typeof this.computationTemplate.metadata.output.viewer !== 'undefined') {
              return this.computationTemplate.metadata.output.viewer;
            }
          }
        }
        return [];
      },
      set(val) {
        // create objects (metadata, output, viewer) if not set yet
        if (typeof this.computationTemplate.metadata === 'undefined') {
          this.$set(this.computationTemplate, 'metadata', { });
        }
        if (typeof this.computationTemplate.metadata.output === 'undefined') {
          this.$set(this.computationTemplate.metadata, 'output', { });
        }
        if (typeof this.computationTemplate.metadata.output.viewer === 'undefined') {
          this.$set(this.computationTemplate.metadata.output, 'viewer', []);
        }

        // set viewer if the user wants to have special output formats
        if (val.length > 1 || (val.length === 1 && val[0] !== '')) {
          if (typeof this.computationTemplate.metadata.output.viewer !== 'undefined') {
            this.$set(this.computationTemplate.metadata.output, 'viewer', val);
          }
        // delete viewer-object if user doesn't want special formats
        } else {
          this.$delete(this.computationTemplate.metadata.output, 'viewer');
        }

        // delete metadata.output if empty
        if (typeof this.computationTemplate.metadata.output.viewer === 'undefined' && typeof this.computationTemplate.metadata.output.csv === 'undefined' && typeof this.computationTemplate.metadata.output.vtk === 'undefined') {
          this.$delete(this.computationTemplate.metadata, 'output');
        }

        this.$forceUpdate();
      },
    },
    vModelFilePath: {
      get() {
        if (typeof this.selectedFile.path !== 'undefined') {
          return this.selectedFile.path;
        }
        return '';
      },
      set(val) {
        this.$set(this.selectedFile, 'path', val);
        if (val === '') {
          this.$delete(this.selectedFile, 'path');
        }
        this.$forceUpdate();
      },
    },
    vModelFileMetadataSyntaxHighlighting: {
      get() {
        if (typeof this.selectedFile.metadata !== 'undefined') {
          if (typeof this.selectedFile.metadata.syntaxHighlighting !== 'undefined') {
            return this.selectedFile.metadata.syntaxHighlighting;
          }
        }
        return '';
      },
      set(val) {
        // if file-metadata object does not exist, create it
        if (typeof this.selectedFile.metadata === 'undefined') {
          this.$set(this.selectedFile, 'metadata', { });
        }
        this.$set(this.selectedFile.metadata, 'syntaxHighlighting', val);

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedFile.metadata, 'syntaxHighlighting');
          if (Object.keys(this.selectedFile.metadata).length === 0) {
            this.$delete(this.selectedFile, 'metadata');
          }
        }

        this.$forceUpdate();
      },
    },
    vModelFileMetadataDescription: {
      get() {
        if (typeof this.selectedFile.metadata !== 'undefined') {
          if (typeof this.selectedFile.metadata.description !== 'undefined') {
            return this.selectedFile.metadata.description;
          }
        }
        return '';
      },
      set(val) {
        // if file-metadata object does not exist, create it
        if (typeof this.selectedFile.metadata === 'undefined') {
          this.$set(this.selectedFile, 'metadata', { });
        }
        this.$set(this.selectedFile.metadata, 'description', val);

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedFile.metadata, 'description');
          if (Object.keys(this.selectedFile.metadata).length === 0) {
            this.$delete(this.selectedFile, 'metadata');
          }
        }

        this.$forceUpdate();
      },
    },
    vModelPartAccess: {
      get() {
        if (typeof this.selectedPart.access !== 'undefined') {
          return this.selectedPart.access;
        }
        // this.$set(this.selectedPart, 'access', '');

        return '';
      },
      set(val) {
        if (typeof this.selectedPart.access !== 'undefined') {
          this.$set(this.selectedPart, 'access', val);
        }

        this.$forceUpdate();
        return this.selectedPart.access;
      },
    },
    vModelPartMetadataName: {
      get() {
        if (typeof this.selectedPart.metadata !== 'undefined') {
          if (typeof this.selectedPart.metadata.description !== 'undefined') {
            return this.selectedPart.metadata.description;
          }
        }
        return '';
      },
      set(val) {
        if (typeof this.selectedPart.metadata !== 'undefined') {
          this.$set(this.selectedPart.metadata, 'description', '');
        } else {
          this.$set(this.selectedPart, 'metadata', { description: '' });
        }

        if (typeof this.selectedPart.metadata.description !== 'undefined') {
          this.$set(this.selectedPart.metadata, 'description', val);
        }

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedPart.metadata, 'description');
          if (Object.keys(this.selectedPart.metadata).length === 0) {
            this.$delete(this.selectedPart, 'metadata');
          }
        }

        this.$forceUpdate();
      },
    },
    vModelParameterIdentifier: {
      get() {
        if (typeof this.selectedParameter.identifier !== 'undefined') {
          return this.selectedParameter.identifier;
        }
        return '';
      },
      set(val) {
        this.$set(this.selectedParameter, 'identifier', val);
        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedParameter, 'identifier');
        }

        this.$forceUpdate();
      },
    },
    vModelParameterMetadataName: {
      get() {
        if (typeof this.selectedParameter.metadata !== 'undefined') {
          if (typeof this.selectedParameter.metadata.name !== 'undefined') {
            return this.selectedParameter.metadata.name;
          }
        }
        return '';
      },
      set(val) {
        if (typeof this.selectedParameter.metadata === 'undefined') {
          this.$set(this.selectedParameter, 'metadata', { name: val });
        } else {
          this.$set(this.selectedParameter.metadata, 'name', val);
        }

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedParameter.metadata, 'name');
        }

        this.$forceUpdate();
      },
    },
    vModelParameterMetadataDescription: {
      get() {
        if (typeof this.selectedParameter.metadata !== 'undefined') {
          if (typeof this.selectedParameter.metadata.description !== 'undefined') {
            return this.selectedParameter.metadata.description;
          }
        }
        return '';
      },
      set(val) {
        if (typeof this.selectedParameter.metadata === 'undefined') {
          this.$set(this.selectedParameter, 'metadata', { description: val });
        } else {
          this.$set(this.selectedParameter.metadata, 'description', val);
        }

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedParameter.metadata, 'description');
        }

        this.$forceUpdate();
      },
    },
    vModelParameterMaxlength: {
      get() {
        if (typeof this.selectedParameter.maxlength !== 'undefined') {
          return this.selectedParameter.maxlength;
        }
        return '';
      },
      set(val) {
        let newValue = parseFloat(val);

        if (Number.isNaN(newValue)) {
          // set to old value, if input was not null
          if (typeof this.selectedParameter !== 'undefined' && val !== '') {
            newValue = this.selectedParameter.maxlength;
          // set to old value if new char was string not number
          } else if (typeof this.selectedParameter !== 'undefined' && val.length > 0) {
            newValue = this.selectedParameter.maxlength;
          // else set value to null
          } else {
            newValue = null;
          }
        }

        this.$set(this.selectedParameter, 'maxlength', newValue);

        // if val is empty, remove object from ct
        if (val === '') {
          this.$delete(this.selectedParameter, 'maxlength');
        }

        this.$forceUpdate();
      },
    },
    ignoreVisualizationDefined: {
      get() {
        return (typeof this.computationTemplate.metadata !== 'undefined')
          && (typeof this.computationTemplate.metadata.output !== 'undefined')
          && (typeof this.computationTemplate.metadata.output.ignore !== 'undefined')
          && (typeof this.computationTemplate.metadata.output.ignore.visualization !== 'undefined');
      },
    },
    ignoreDownloadDefined: {
      get() {
        return (typeof this.computationTemplate.metadata !== 'undefined')
          && (typeof this.computationTemplate.metadata.output !== 'undefined')
          && (typeof this.computationTemplate.metadata.output.ignore !== 'undefined')
          && (typeof this.computationTemplate.metadata.output.ignore.download !== 'undefined');
      },
    },
  },
  watch: {
    computationTemplate: {
      handler() {
        // reset iFrame, if computation task is modified
        const iFrameDiv = document.getElementById('iframe-div');
        iFrameDiv.innerHTML = '';

        // check if properties are empty and delete
        const emptyProperties = [];
        Object.entries(this.computationTemplate.configuration).forEach(([key, value]) => {
          if (value === '') {
            emptyProperties.push(key);
          }
        });
        emptyProperties.forEach((key) => this.$delete(this.computationTemplate.configuration, key));

        // TODO: check if metadata.output is empty and delete

        // update generated CT in Vuex-Store
        this.$store.commit('updateGeneratedComputationTemplate', this.computationTemplate);

        // reset validation as it is no longer up-to-date
        this.validationResult = null;
        this.validationPartParameterResult = null;
        this.validationArgsResult = null;
        this.validationRunning = false;

        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    // Make the function wait until the connection is made...
    waitForSocketConnection(context, socket, callback) {
      setTimeout(() => {
        if (socket.readyState === 1) {
          if (callback != null) {
            callback();
          }
        } else {
          context.waitForSocketConnection(context, socket, callback);
        }
      }, 5); // wait 5 milisecond for the connection...
    },
    sendWaiting(msg) {
      this.waitForSocketConnection(this, this.ws, () => {
        this.ws.send(msg);
      });
    },
    paramAccordeon(id) {
      return `${id}param`;
    },
    contentAccordeon(id) {
      return `${id}content`;
    },
    onInsert(event, isPart, part) {
      if (isPart) {
        part.parameters.splice(event.index, 0, event.data);
      } else {
        part.parts.splice(event.index, 0, event.data);
      }
    },
    onFileDrop(e) {
      if (e.data === 'file') {
        const file = {
          identifier: this.uuid(),
          path: '',
          metadata: {
            syntaxHighlighting: 'text',
          },
          parts: [],
        };
        this.computationTemplate.files.push(file);
        // add possibility to add "parts"
        this.componentsCommand = this.componentsPart.concat(this.componentsCommand);
      // add commandline parameters
      } else if (typeof this.computationTemplate.parameters === 'undefined') {
        this.computationTemplate.parameters = [];
        // remove possibility to add commandline params
        this.componentsFiles = ['file'];
        this.$forceUpdate();
      }
    },
    onPartDrop(e, file) {
      const part = {
        identifier: this.uuid(),
        access: 'modifiable',
        content: '',
      };
      file.parts.push(part);
    },
    onParameterDrop(e, part = null) {
      let parameter = {};
      if (e.data === 'input_field') {
        parameter = {
          mode: 'any',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            type: '',
            name: 'Name',
            description: 'Add your description here...',
          },
          default: [''],
          validation: 'none',
        };
      } else if (e.data === 'slider') {
        parameter = {
          mode: 'any',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
            vertical: false,
          },
          default: [0],
          min: 0,
          max: 100,
          step: 1,
          validation: 'none',
        };
      } else if (e.data === 'editor') {
        parameter = {
          mode: 'any',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
          },
          default: [''],
          validation: 'none',
        };
      } else if (e.data === 'checkbox') {
        parameter = {
          mode: 'fixed',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
          },
          options: [
            {
              value: 'value',
              text: 'label',
              selected: false,
              disabled: false,
            },
          ],
          validation: 'anyof',
        };
      } else if (e.data === 'radio') {
        parameter = {
          mode: 'fixed',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
          },
          options: [
            {
              value: 'value',
              text: 'label',
              selected: false,
              disabled: false,
            },
          ],
          validation: 'oneof',
        };
      } else if (e.data === 'dropdown') {
        parameter = {
          mode: 'fixed',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
          },
          options: [
            {
              value: 'value',
              text: 'label',
              selected: false,
              disabled: false,
            },
          ],
          validation: 'oneof',
        };
      } else if (e.data === 'toggle') {
        parameter = {
          mode: 'fixed',
          identifier: this.uuid(),
          metadata: {
            guiType: e.data,
            name: 'Name',
            description: 'Add your description here...',
          },
          options: [
            {
              value: 'value',
              text: 'label',
              selected: false,
              disabled: false,
            },
          ],
          validation: 'anyof',
        };
      } else {
        parameter = {
          identifier: this.uuid(),
          metadata: { guiType: e.data },
        };
      }
      // if part in set, add parameter to part, else add it to commanline parameters
      if (part !== null) {
        part.parameters.push(parameter);
      } else {
        this.computationTemplate.parameters.push(parameter);
      }
      this.$forceUpdate();
    },
    remove(n) {
      const index = this.numbers.indexOf(n);
      this.numbers.splice(index, 1);
    },
    openWindow(event, type, content) {
      event.stopPropagation();
      this.closePreferences();
      this.preferences = true;
      if (type === 'parameter') {
        this.selectedParameter = content;
        this.showParameter = true;
      } else if (type === 'part') {
        this.selectedPart = content;
        this.showPart = true;
      } else if (type === 'file') {
        this.selectedFile = content;
        this.showFile = true;
      } else if (type === 'commands') {
        this.showCommands = true;
      } else {
        if (this.computationTemplate.identifier === '') {
          this.computationTemplate.identifier = this.uuid();
        }
        this.showTemplate = true;
      }
    },
    closePreferences() {
      this.preferences = false;
      this.selectedParameter = {};
      this.selectedPart = {};
      this.selectedFile = {};
      this.showParameter = false;
      this.showPart = false;
      this.showFile = false;
      this.showTemplate = false;
      this.showCommands = false;
    },
    /** create uuid for the parameters */
    uuid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        `${s4()
        + s4()
        }-${
          s4()
        }-${
          s4()
        }-${
          s4()
        }-${
          s4()
        }${s4()
        }${s4()}`
      );
    },
    /* eslint no-param-reassign: ["error", { "props": false }] */
    addOrRemoveParameters(selectedPart) {
      if (selectedPart.access === 'template' && (typeof selectedPart.parameters === 'undefined')) {
        this.$set(selectedPart, 'parameters', []);
      } else if (selectedPart.access !== 'template') {
        delete selectedPart.parameters;
      }
    },
    /**
     * Delete Parameter from part or command line arguments and rerender
     */
    removeParameter(event, item, isInPart = true) {
      event.stopPropagation();
      if (isInPart) {
        Object.values(this.computationTemplate.files).forEach((file) => {
          Object.values(file.parts).forEach((part) => {
            Object.keys(part.parameters).forEach((parameter) => {
              const currentParameter = part.parameters[parameter];
              if (currentParameter.identifier === item.identifier) {
                delete part.parameters.splice(parameter, 1);
                this.closePreferences();
                this.showTemplate = true;
                this.preferences = true;
              }
            });
          });
        });
      } else {
        Object.keys(this.computationTemplate.parameters).forEach((argument) => {
          const currentParameter = this.computationTemplate.parameters[argument];
          if (currentParameter.identifier === item.identifier) {
            delete this.computationTemplate.parameters.splice(argument, 1);
            this.closePreferences();
            this.showCommands = true;
            this.preferences = true;
          }
        });
      }
      this.$forceUpdate();
    },
    /**
     * Delete file from json and rerender
     */
    removeFile(event, item) {
      event.stopPropagation();
      Object.keys(this.computationTemplate.files).forEach((fileIndex) => {
        if (this.computationTemplate.files[fileIndex].identifier === item.identifier) {
          delete this.computationTemplate.files.splice(fileIndex, 1);
        }
      });
      this.closePreferences();
      this.preferences = true;
      this.showTemplate = true;

      // if there are no files, remove ability to add parts
      if (this.computationTemplate.files.length === 0) {
        this.componentsCommand = ['checkbox', 'radio', 'dropdown', 'toggle'];
      }

      this.$forceUpdate();
    },
    /**
     * Delete part from json and rerender
     */
    removePart(event, item) {
      event.stopPropagation();
      Object.values(this.computationTemplate.files).forEach((file) => {
        Object.keys(file.parts).forEach((partIndex) => {
          if (file.parts[partIndex].identifier === item.identifier) {
            delete file.parts.splice(partIndex, 1);
          }
        });
      });
      this.closePreferences();
      this.preferences = true;
      this.showTemplate = true;
      this.$forceUpdate();
    },
    /**
     * Delete commandline args from json and rerender
     */
    removeCommandlineArgs(event) {
      event.stopPropagation();
      delete this.computationTemplate.parameters;
      this.componentsFiles.push('commandline arguments');
      this.closePreferences();
      this.preferences = true;
      this.showTemplate = true;
      this.$forceUpdate();
    },
    removeConfig(event, isCsv, config) {
      event.stopPropagation();
      let configObject;
      if (isCsv) {
        configObject = this.computationTemplate.metadata.output.csv;
      } else {
        configObject = this.computationTemplate.metadata.output.vtk;
      }
      Object.values(configObject).forEach((configItem) => {
        if (configItem.basename === config.basename) {
          this.$delete(configObject, configItem);

          // if csv-object is empty, delete it
          if (configObject.length === 0) {
            if (isCsv) {
              this.$delete(this.computationTemplate.metadata.output, 'csv');
            } else {
              this.$delete(this.computationTemplate.metadata.output, 'vtk');
            }
          }

          this.$forceUpdate();
        }
      });

      // delete metadata.output if empty
      if (typeof this.computationTemplate.metadata.output.viewer === 'undefined' && typeof this.computationTemplate.metadata.output.csv === 'undefined' && typeof this.computationTemplate.metadata.output.vtk === 'undefined') {
        this.$delete(this.computationTemplate.metadata, 'output');
      }

      this.$forceUpdate();
    },
    removePlot(event, csv, plotConf) {
      event.stopPropagation();
      const configObject = this.computationTemplate.metadata.output.csv;
      Object.values(configObject).forEach((configItem) => {
        if (configItem.basename === csv.basename) {
          Object.keys(configItem.plots).forEach((plot) => {
            if (configItem.plots[plot].key === plotConf.key) {
              this.$delete(configItem.plots, plot);
            }
          });
        }
      });
      this.$forceUpdate();
    },
    /**
     * input_field
     * adjust parts of input-field json, depending on type
     */
    adjustInputType(item) {
      const { type } = item.metadata;
      if (type === 'text') {
        this.$delete(item, 'min');
        this.$delete(item, 'max');
        this.$delete(item, 'step');
      } else if (type === 'number') {
        this.$delete(item, 'maxlength');
      }
      this.$set(item.default, 0, '');
    },
    /**
     * validation - type: pattern
     * adjust whether pattern-object exists in json
     */
    adjustPatternExistence(item) {
      const { validation } = item;
      if (validation !== 'pattern') {
        delete item.pattern;
      }
      this.$forceUpdate();
    },
    addConfig() {
      const env = this.computationTemplate.environment;
      if (typeof this.computationTemplate.configuration === 'undefined') {
        this.$set(this.computationTemplate, 'configuration', {});
      }
      if (typeof this.computationTemplate.configuration['running.timelimitInSeconds'] === 'undefined') {
        this.$set(this.computationTemplate.configuration, 'running.timelimitInSeconds', 0);
      }
      // TODO: Add environments as they are supported by the backend
      // eslint-disable-next-line default-case
      switch (env) {
        // case "C":
        //   this.$set(this.computationTemplate.configuration, "compiling.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "compiling.compiler", "");
        //   this.$set(this.computationTemplate.configuration, "compiling.flags", "");
        //   this.$set(this.computationTemplate.configuration, "checking.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "checking.forbiddenCalls", "");
        //   this.$set(this.computationTemplate.configuration, "linking.flags", "");
        //   this.$set(this.computationTemplate.configuration, "running.commandLineArguments", "");
        //   break;
        // case "C++":
        //   this.$set(this.computationTemplate.configuration, "compiling.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "compiling.compiler", "");
        //   this.$set(this.computationTemplate.configuration, "compiling.flags", "");
        //   this.$set(this.computationTemplate.configuration, "linking.flags", "");
        //   this.$set(this.computationTemplate.configuration, "running.commandLineArguments", "");
        //   break;
        // case "Java":
        //   this.$set(this.computationTemplate.configuration, "compiling.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "compiling.flags", "");
        //   this.$set(this.computationTemplate.configuration, "checking.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "checking.allowedCalls", "");
        //   this.$set(this.computationTemplate.configuration, "checking.forbiddenCalls", "");
        //   this.$set(this.computationTemplate.configuration, "running.commandLineArguments", "");
        //   this.$set(this.computationTemplate.configuration, "running.flags", "");
        //   this.$set(this.computationTemplate.configuration, "running.mainClass", "");
        //   break;
        // case "Matlab":
        //   this.$set(this.computationTemplate.configuration, "checking.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "checking.allowedCalls", "");
        //   this.$set(this.computationTemplate.configuration, "running.stdinFilename", "");
        //   break;
        // case "Octave":
        //   this.$set(this.computationTemplate.configuration, "checking.sources", [ "" ]);
        //   this.$set(this.computationTemplate.configuration, "checking.allowedCalls", "");
        //   this.$set(this.computationTemplate.configuration, "running.stdinFilename", "");
        //   break;
        case 'Container':
          if (typeof this.computationTemplate.configuration['running.commandLineArguments'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'running.commandLineArguments', '');
          }
          if (typeof this.computationTemplate.configuration['running.entrypoint'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'running.entrypoint', '');
          }
          if (typeof this.computationTemplate.configuration['running.intermediateFilesPattern'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'running.intermediateFilesPattern', ['']);
          }
          if (typeof this.computationTemplate.configuration['running.userId'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'running.userId', 0);
          }
          if (typeof this.computationTemplate.configuration['resources.image'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'resources.image', '');
          }
          if (typeof this.computationTemplate.configuration['resources.volume'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'resources.volume', '');
          }
          if (typeof this.computationTemplate.configuration['resources.memory'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'resources.memory', '');
          }
          if (typeof this.computationTemplate.configuration['resources.numCPUs'] === 'undefined') {
            this.$set(this.computationTemplate.configuration, 'resources.numCPUs', 1);
          }
          break;
        // case "DuMuX":
        //   this.$set(this.computationTemplate.configuration, "running.commandLineArguments", "");
        //   this.$set(this.computationTemplate.configuration, "running.executable", "");
        //   break;
      }
    },
    /** Check if property exists in current config, or if it is undefined */
    ifConfigPropertyExists(property) {
      const config = this.computationTemplate.configuration;
      if (typeof config[property] !== 'undefined') {
        return true;
      }
      return false;
    },
    addCsvConfig() {
      const outputConfig = {
        basename: 'csv-basename',
        xlabel: {
          key: 'x-key',
          label: 'x-label',
        },
        plots: [
          {
            key: 'y-key',
            label: 'y-label',
          },
        ],
      };
      if (typeof this.computationTemplate.metadata === 'undefined') {
        this.$set(this.computationTemplate, 'metadata', { });
      }
      if (typeof this.computationTemplate.metadata.output === 'undefined') {
        this.$set(this.computationTemplate.metadata, 'output', { });
      }
      if (typeof this.computationTemplate.metadata.output.csv === 'undefined') {
        this.$set(this.computationTemplate.metadata.output, 'csv', []);
      }
      this.computationTemplate.metadata.output.csv.push(outputConfig);
    },
    // TODO merge visualization and download
    addIgnoreVisualization() {
      // output-ignore-visualization-input
      if (typeof this.computationTemplate.metadata === 'undefined') {
        this.$set(this.computationTemplate, 'metadata', { });
      }
      if (typeof this.computationTemplate.metadata.output === 'undefined') {
        this.$set(this.computationTemplate.metadata, 'output', { });
      }
      if (typeof this.computationTemplate.metadata.output.ignore === 'undefined') {
        this.$set(this.computationTemplate.metadata.output, 'ignore', { });
      }
      if (typeof this.computationTemplate.metadata.output.ignore.visualization === 'undefined') {
        this.$set(this.computationTemplate.metadata.output.ignore, 'visualization', []);
      }
      this.computationTemplate.metadata.output.ignore.visualization.push(this.outputIgnoreVisualization);
      this.outputIgnoreVisualization = '';
    },
    removeIgnoreVisualization(ignoreItem) {
      const itemIndex = this.computationTemplate.metadata.output.ignore.visualization.indexOf(ignoreItem);
      this.computationTemplate.metadata.output.ignore.visualization.splice(itemIndex, 1);
    },
    addIgnoreDownload() {
      // output-ignore-visualization-input
      if (typeof this.computationTemplate.metadata === 'undefined') {
        this.$set(this.computationTemplate, 'metadata', { });
      }
      if (typeof this.computationTemplate.metadata.output === 'undefined') {
        this.$set(this.computationTemplate.metadata, 'output', { });
      }
      if (typeof this.computationTemplate.metadata.output.ignore === 'undefined') {
        this.$set(this.computationTemplate.metadata.output, 'ignore', { });
      }
      if (typeof this.computationTemplate.metadata.output.ignore.download === 'undefined') {
        this.$set(this.computationTemplate.metadata.output.ignore, 'download', []);
      }
      this.computationTemplate.metadata.output.ignore.download.push(this.outputIgnoreDownload);
      this.outputIgnoreDownload = '';
    },
    removeIgnoreDownload(ignoreItem) {
      const itemIndex = this.computationTemplate.metadata.output.ignore.download.indexOf(ignoreItem);
      this.computationTemplate.metadata.output.ignore.download.splice(itemIndex, 1);
    },
    addCsvPlot(csvConfigIndex) {
      const plotConfig = {
        key: 'y-key',
        label: 'y-label',
      };
      if (typeof this.computationTemplate.metadata.output.csv[csvConfigIndex].plots === 'undefined') {
        this.$set(this.computationTemplate.metadata.output.csv[csvConfigIndex], 'plots', []);
      }
      this.computationTemplate.metadata.output.csv[csvConfigIndex].plots.push(plotConfig);
    },
    addVtkConfig() {
      const outputConfig = {
        basename: 'vtk-basename',
      };
      if (typeof this.computationTemplate.metadata === 'undefined') {
        this.$set(this.computationTemplate, 'metadata', { });
      }
      if (typeof this.computationTemplate.metadata.output === 'undefined') {
        this.$set(this.computationTemplate.metadata, 'output', { });
      }
      if (typeof this.computationTemplate.metadata.output.vtk === 'undefined') {
        this.$set(this.computationTemplate.metadata.output, 'vtk', []);
      }
      this.computationTemplate.metadata.output.vtk.push(outputConfig);
    },
    updateContent(item, event) {
      // this.computationTemplate.files[fileIndex].parts[partIndex].content = event
      item.content = event;
    },
    setEditorValue(event) {
      this.$set(this.selectedParameter.default, 0, event);
      this.$forceUpdate();
    },
    getNumberOfFields(paramId) {
      if (this.valueNumbers.get(paramId) === undefined) {
        this.valueNumbers.set(paramId, 1);
        return 1;
      }
      return this.valueNumbers.get(paramId);
    },
    setNumberOfFields(paramId, newValue) {
      if (this.selectedParameter.metadata.guiType === 'checkbox') {
        if (newValue < this.getNumberOfFields(paramId)) {
          this.selectedParameter.options.pop();
          this.$forceUpdate();
        }
      }
      this.valueNumbers.set(paramId, newValue);
      this.$forceUpdate();
    },
    getNumberofConfigFields(configName) {
      if (this.computationTemplate.configuration[configName] === undefined) {
        return 0;
      }
      return this.computationTemplate.configuration[configName].length;
    },
    setNumberOfConfigFields(configName, newValue) {
      if (newValue < this.getNumberofConfigFields(configName)) {
        this.computationTemplate.configuration[configName].pop();
        if (newValue === 0) {
          this.$delete(this.computationTemplate.configuration, configName);
        }
        this.$forceUpdate();
      } else if (newValue !== 0) {
        if (this.getNumberofConfigFields(configName) === 0) {
          this.computationTemplate.configuration[configName] = [''];
        } else {
          this.computationTemplate.configuration[configName].push('');
        }
      }
      this.$forceUpdate();
    },
    getConfigvModel(configName, index = 0) {
      if (index != null) {
        if (typeof this.computationTemplate.configuration[configName] !== 'undefined') {
          if (this.computationTemplate.configuration[configName].length > 0) {
            return this.computationTemplate.configuration[configName][index];
          }
        }
      } else if (typeof this.computationTemplate.configuration[configName] !== 'undefined') {
        return this.computationTemplate.configuration[configName];
      }
      return '';
    },
    setConfigvModel(configName, val, index = 0, isNumericalValue = false) {
      // if config element is an array
      if (index != null) {
        if (typeof this.computationTemplate.configuration[configName] !== 'undefined') {
          this.$set(this.computationTemplate.configuration[configName], index, val.target.value);
        } else {
          this.computationTemplate.configuration[configName] = [val.target.value];
        }

      // if config element is not an array
      } else {
        let newValue;

        // if the value has to be a number, check it
        if (isNumericalValue) {
          newValue = parseFloat(val.target.value);
          if (Number.isNaN(newValue)) {
            // set to old value, if input was not null
            console.log(val.target.value);
            if (typeof this.computationTemplate.configuration[configName] !== 'undefined' && val.target.value !== '') {
              newValue = this.computationTemplate.configuration[configName];
            // set to old value if new char was string not number
            } else if (typeof this.computationTemplate.configuration[configName] !== 'undefined' && val.target.value === '') {
              newValue = null;// this.computationTemplate.configuration[configName];
            // else set value to null
            } else {
              newValue = null;
            }
          }
        } else {
          newValue = val.target.value;
        }

        console.log(newValue);

        // set existing value or create config-element and set it
        if (typeof this.computationTemplate.configuration[configName] !== 'undefined') {
          this.$set(this.computationTemplate.configuration, configName, newValue);
        } else {
          this.computationTemplate.configuration[configName] = newValue;
        }

        // delete config element if set to null or empty string
        if (newValue === null || newValue === '') {
          this.$set(this.computationTemplate.configuration, configName, newValue);
          this.$delete(this.computationTemplate.configuration, configName);
        }
      }
      this.$forceUpdate();
    },
    getSlidervModel(index) {
      if (this.selectedParameter.default.length > 0) {
        return this.selectedParameter.default[index];
      }
      return NaN;
    },
    setSlidervModel(val, index) {
      if (typeof this.selectedParameter !== 'undefined') {
        if (val.target.value === '') {
          this.$set(this.selectedParameter.default, index, '');
        } else {
          console.log(val.target.value);
          if (val.target.value === '0.0') {
            this.$set(this.selectedParameter.default, index, val.target.value);
          } else {
            this.$set(this.selectedParameter.default, index, parseFloat(val.target.value));
          }
        }
      }
      this.$forceUpdate();
    },
    getFixedParamvModel(index, whatToGet = 'value') {
      if (this.selectedParameter.options.length > 0) {
        if (typeof this.selectedParameter.options[index] === 'undefined') {
          const option = {
            value: '',
            text: '',
            selected: false,
            disabled: false,
          };
          this.selectedParameter.options.push(option);
        }
        return this.selectedParameter.options[index][whatToGet];
      }
      return '';
    },
    /**
     * Sets value, selected or disabled in options-object
     * whatToSet: "value" || "selected" || "disabled"
     */
    setFixedParamvModel(val, index, whatToSet) {
      if (typeof this.selectedParameter !== 'undefined') {
        if (typeof this.selectedParameter.options[index] === 'undefined') {
          const option = {
            value: '',
            selected: false,
            disabled: false,
          };
          this.selectedParameter.options.push(option);
        }
        // if selected or disabled, set value as boolean - not as string
        if (whatToSet === 'selected' || whatToSet === 'disabled') {
          const isSetTrue = (val.target.value === 'true');
          this.$set(this.selectedParameter.options[index], whatToSet, isSetTrue);
          if (this.selectedParameter.metadata.guiType === 'radio' && isSetTrue) {
            const radioOptions = this.selectedParameter.options;
            Object.keys(radioOptions).forEach((radioOption) => {
              if (radioOption !== index) {
                this.$set(radioOptions[radioOption], whatToSet, false);
              }
            });
          }
        } else if (val.target.value === '' && whatToSet === 'text') {
          this.$delete(this.selectedParameter.options[index], 'text');
        } else {
          this.$set(this.selectedParameter.options[index], whatToSet, val.target.value);
        }
        // if dropdown and multiple fields are selected
        if (this.selectedParameter.metadata.guiType === 'dropdown') {
          const selected = [];
          Object.keys(this.selectedParameter.options).forEach((opt) => {
            const keys = Object.keys(this.selectedParameter.options[opt]);
            if (keys.includes('selected')) {
              if (this.selectedParameter.options[opt].selected) {
                selected.push(opt);
              }
            }
          });
          if (selected.length > 1) {
            this.$set(this.selectedParameter, 'multiple', true);
          } else {
            this.$set(this.selectedParameter, 'multiple', false);
          }
        }
        this.$forceUpdate();
        // return this.slidervModel;
      }
    },
    getRadioSelected(index) {
      if (typeof this.selectedParameter.options[index] !== 'undefined') {
        return this.selectedParameter.options[index].selected;
      }
      return false;
    },
    getvModelTemplateMetadata(propertyName) {
      if (typeof this.computationTemplate.metadata === 'undefined') {
        this.$set(this.computationTemplate, 'metadata', { });
      }
      if (typeof this.computationTemplate.metadata[propertyName] !== 'undefined') {
        return this.computationTemplate.metadata[propertyName];
      }
      return '';
    },
    setvModelTemplateMetadata(propertyName, val) {
      if (val.target.value !== '') {
        if (typeof this.computationTemplate.metadata[propertyName] !== 'undefined') {
          this.$set(this.computationTemplate.metadata, propertyName, val.target.value);
          this.$forceUpdate();
        } else if (typeof this.computationTemplate.metadata === 'undefined') {
          this.$set(this.computationTemplate, 'metadata', { });
          this.$set(this.computationTemplate.metadata, propertyName, val.target.value);
        } else {
          this.$set(this.computationTemplate.metadata, propertyName, val.target.value);
        }
        // return this.computationTemplate.metadata[propertyName];
      // if val is empty delete displayName-element
      } else if (typeof this.computationTemplate.metadata[propertyName] !== 'undefined') {
        this.$delete(this.computationTemplate.metadata, propertyName);
        // this.$forceUpdate();
      }
      this.$forceUpdate();
    },
    /**
     * validate computation template and return whether button should be enabled
     */
    validateJson(event, uploaded = false) {
      if (!uploaded) {
        this.validationRunning = true;
      }

      // reset validation
      this.validationResult = null;
      this.validationPartParameterResult = null;
      this.validationArgsResult = null;

      // ct validation
      // TODO if environment can be more than "Container" validate depending on that
      const ajv = new Ajv();
      const validate = ajv.compile(this.schema);
      validate(this.computationTemplate);
      this.validationResult = validate.errors;

      // parameter validation
      const { files } = this.computationTemplate;
      const paramValidate = ajv.compile(this.paramSchema);
      Object.values(files).forEach((file) => {
        Object.values(file.parts).forEach((part) => {
          if (typeof part.parameters !== 'undefined') {
            paramValidate(part.parameters);
            this.validationPartParameterResult = paramValidate.errors;
          }
        });
      });

      // commandline arguments validation
      const commandlineValidate = ajv.compile(this.commandlineArgsSchema);
      if (typeof this.computationTemplate.parameters !== 'undefined' && this.computationTemplate.parameters !== []) {
        commandlineValidate(this.computationTemplate.parameters);
        this.validationArgsResult = commandlineValidate.errors;
      }

      if (!uploaded) {
        // if everything is valid, set validationResult to "Template is Valid!"
        if (this.validationResult == null && this.validationPartParameterResult == null && this.validationArgsResult == null) {
          this.validationResult = 'Template is Valid!';
          setTimeout(() => { this.validationRunning = false; }, 2000);
          this.classValidity = 'valid-true';
          return true;
        }

        setTimeout(() => { this.validationRunning = false; }, 2000);
        this.classValidity = 'valid-false';
      } else if (this.validationResult == null && this.validationPartParameterResult == null && this.validationArgsResult == null) {
        return true;
      }
      return false;
    },
    /** Check if teacher-frontend was opened by a user that is signed in */
    isLoggedIn() {
      const appDiv = document.body;
      const dataMode = appDiv.getAttribute('data-mode');
      // if data-mode is set to "create-and-execute", user is logged in (if it is set to "created", the user is not logged in)
      const loggedIn = ((dataMode === 'create-and-execute'));
      return loggedIn;
    },
    startGuide() {
      this.$tours.myTour.start();
    },
    /* upload existing Computation Template JSON */
    uploadCT(event) {
      const iFrameDiv = document.getElementById('iframe-div');
      iFrameDiv.innerHTML = '';
      const reader = new FileReader();
      reader.onload = this.onReaderLoad;
      reader.readAsText(event.target.files[0]);
    },
    /* get json from uploaded file und update DOM */
    onReaderLoad(event) {
      const obj = JSON.parse(event.target.result);

      // close preferences of previous template and show cofig of new ct in preferences-window
      this.closePreferences();
      this.preferences = true;
      this.showTemplate = true;

      //  add required elements that might be missing
      if (typeof obj.files !== 'undefined') {
        Object.values(obj.files).forEach((file) => {
          // add file-identifiers if missing
          if (typeof file.identifier === 'undefined') {
            this.$set(file, 'identifier', this.uuid());
          }
          // add "parts"-elements
          if (typeof file.parts === 'undefined') {
            this.$set(file, 'parts', []);
          }
          // add required elements in parts
          Object.values(file.parts).forEach((part) => {
            // add identifiers if missing
            if (typeof part.identifier === 'undefined') {
              this.$set(part, 'identifier', this.uuid());
            }
            // add content if missing
            if (typeof part.content === 'undefined') {
              this.$set(part, 'content', '');
            }
            // if access is already set to template
            if (typeof part.access !== 'undefined') {
              if (part.access === 'template') {
                // add parameters
                if (typeof part.parameters === 'undefined') {
                  this.$set(part, 'parameters', []);
                }
              }
            }
          });
        });
      } else {
        this.$set(obj, 'files', []);
      }

      // add template identifier
      if (typeof obj.identifier === 'undefined') {
        this.$set(obj, 'identifier', this.uuid());
      }

      // TODO: Container needs configuration, but other environments might not need it (take that into account as backend supports more)
      // add configutation
      if (typeof obj.configuration === 'undefined') {
        this.$set(obj, 'configuration', {});
      }

      // TODO: Should also function without metadata as it is not required
      // add metadata if missing

      // save current template, as it will be overwritten to perform validation
      const tmp = this.computationTemplate;
      // set generatedTemplate/computationTemplate so validation can be performed
      this.$store.commit('updateGeneratedComputationTemplate', obj);
      const isValid = this.validateJson(true);
      if (!isValid) {
        this.$alert('Your template is not valid. Thus, it can not be imported!', 'Import Error', 'error');
        this.$store.commit('updateGeneratedComputationTemplate', tmp);
      } else {
        this.$store.commit('updateGeneratedComputationTemplate', obj);
        this.signifyChange = !this.signifyChange;
        // set number of options for configuring parameters and commandline arguments
        this.setNumbersOfOptions();
      }

      this.$forceUpdate();
    },
    setNumbersOfOptions() {
      // set numbers of parameter-values
      Object.values(this.computationTemplate.files).forEach((file) => {
        Object.values(file.parts)
          .filter((part) => part.access === 'template')
          .forEach((part) => {
            Object.values(part.parameters)
              .filter((currentParam) => currentParam.mode === 'fixed')
              .forEach((currentParam) => { this.valueNumbers.set(currentParam.identifier, currentParam.options.length); });
          });
      });
      // set number of commandline argument-values
      if (typeof this.computationTemplate.parameters !== 'undefined') {
        Object.values(this.computationTemplate.parameters)
          .filter((parmeter) => parmeter.mode === 'fixed')
          .forEach((parameter) => {
            this.valueNumbers.set(parameter.identifier, parameter.options.length);
          });
      }
    },
    /** Run created template in another tab */
    runTemplate() {
      if (this.validateJson()) {
        const url = window.location;
        const baseUrl = `${url.protocol}//${url.host}/`;

        // calculate data-template for frontend-preview
        const file = JSON.stringify(this.computationTemplate);
        const dataBase64url = base64url(Buffer.from(file).toString());

        // baseUrl = "http://localhost:3000/";
        fetch(`${baseUrl}sign`, {
          method: 'POST',
          body: dataBase64url,
        }).then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Request failed!');
        }, (networkError) => {
          console.log(networkError.message);
        }).then((jsonResponse) => {
          // get token from sign-endpoint
          const { token } = jsonResponse;

          // set all values in Vuex store
          this.$store.commit('updateModifiedByTeacher', true);
          this.$store.commit('updateJsonTemplate', this.computationTemplate);
          this.$store.commit('updateToken', token);
          this.$store.commit('updateDataTemplate', dataBase64url);

          // authenticate with new token
          /* this.ws = new WebSocket(this.$config.WEBSOCKET_API);
          let message = JSON.stringify({ type: "authenticate", content: { jwt: token } });
          this.sendWaiting(message) */

          // preview ct in iFrame
          const iFrameDiv = document.getElementById('iframe-div');
          iFrameDiv.innerHTML = '';
          const iFrame = document.createElement('iframe');
          iFrameDiv.appendChild(iFrame);
          iFrame.setAttribute('src', url.href.replace('#/teacher', ''));
          iFrame.setAttribute('width', '100%');
          iFrame.setAttribute('height', '315');
        });
      } else {
        this.$alert('Your template is not valid. Thus, it can not be executed!', 'Execution Error', 'error');
      }
    },
    downloadCT() {
      console.log('clicked');
      const isValid = this.validateJson();

      if (isValid) {
        const dataStr = `data:text/json;charset=utf-8,${
          encodeURIComponent(JSON.stringify(this.computationTemplate))}`;
        const exportName = this.computationTemplate.identifier;
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', `${exportName}.json`);
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      } else {
        this.$alert('Your template is not valid. Thus, it can not be saved!', 'Download Error', 'error');
      }
    },
  },
  created() {

  },
  mounted() {
    // generate id for ct
    this.computationTemplate.identifier = this.uuid();
    this.setNumbersOfOptions();
  },
};
</script>

<style lang="scss">
body {
  /* Needed for the position sticky to work */
  overflow: unset !important;
}

#injected #teacher {

  .teacher-header {
    /*position: fixed;*/
    min-height: 200px;
    left: 0;
    right: 0;
    top: 0;
    background: linear-gradient(110deg, #004191 60%, #00BEFF 60%);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .teacher-header::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*background-color: MidnightBlue;*/
    opacity: 0.3;
  }

  .teacher-header-section {
    position: relative;
    margin-top: auto;
    margin-bottom: auto;
    color: white;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
    font-family: "Montserrat", sans-serif;
  }

  .ct-docu-link {
    color: white;
  }

  .ct-docu-link:hover {
    color: #004191;
  }

  .header {
    overflow: hidden;
    position: relative;
  }

  /* Style the header links */
  .header img {
    float: left;
    border-radius: calc(0.25rem - 1px);
  }

  .header-right {
    text-align: center;
    font-size: 5vw;
    width: 50%;
    position: absolute;
    top: 50%;
    right: 0;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .header-intro {
    position: relative;
    z-index: 100;
  }

  .outer-div {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 10px;

    margin: 0 !important;
  }

  .main-div {
    /*position: relative;*/
    background-color: #fff;
    border-radius: calc(0.25rem - 1px);
    /*top: 200px;*/
  }

  .validation-div {
    position: relative;
    background-color: #fff;
    border-radius: calc(0.25rem - 1px);
  }

  .item-name {
    font-weight: bold;
    font-size: 14pt;
  }

  .drag {
    padding: 10px;
    background-color: rgba(0, 190, 255, 0.2);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 10px 0;
    /*font-size: 20px;*/
    transition: all 0.5s;
    width: 100%;
    text-align: center;
  }

  .drop-allowed{
    background-color: rgba(0, 255, 0, .4) !important;
  }

  .drop-forbidden  {
    background-color: rgba(255, 0, 0, 0.2);
  }

  .card-body {
    height: 100% !important;
  }

  .group {
    display: flex;
    position:relative;
    background-color: #fff;
  }

  .teacher-section-wrap {
    position:relative;
    background-color: #fff;
  }

  .select-list {
    margin: 20px 10px 20px 10px;
    width: 20%;
  }

  .preferences-list {
    padding: 0 10px 10px 10px;
    word-break: break-word;
  }

  .dnd-window {
    position: relative;
    flex: 1;
    width: 70%;
    margin: 20px 10px 20px 10px;
  }

  .top-copy {
    /*border: 1px solid black;*/
    min-height: 100px;
    position: relative;
    flex: 1;
    width: 100%;
    height: 100%;
    font-size: 1em;
  }

  .top-copy::before {
    /*content: "Drop Components Here";*/
    color: rgba(0, 0, 0, 0.4);
    font-size: 25px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 0;
  }

  .copy {
    border: 1px solid #dee2e6;
    min-height: 100px;
    margin: 20px auto 20px auto;
    position: relative;
    flex: 1;
    width: 80%;
  }

  .card {
    background-color: rgba(0, 0, 0, 0);
    height: 100%;
  }

  .card-body {
    padding: 0 !important;
  }

  .param-droplist {
    width: 80%;
    margin: auto;
  }

  .part-droplist {
    margin: 20px auto 20px auto;
    width: 80%;
  }

  .part-border {
    border: 1px solid #dee2e6;
  }

  .part-drag {
    /*border: 1px solid black;*/
    min-height: 100px;
    margin: 20px auto 20px auto;
    position: relative;
    flex: 1;
    /*width: 70%;*/
    cursor: pointer;
    z-index: 100;
  }

  .param {
    border: 1px solid #dee2e6;
    min-height: 100px;
    margin: 20px auto 20px auto;
    position: relative;
    flex: 1;
    cursor: pointer;
    z-index: 100;
  }

  .param-container {
    min-height: 100px;
  }

  .template, .file, .part {
    min-height: 100px;
    position: relative;
    flex: 1;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .copy::before {
    //content: "COPY";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(0, 0, 0, 0.4);
    font-size: 25px;
    font-weight: bold;
  }

  .drop-allowed {
    background-color: rgba(0, 255, 0, 0.2);
  }

  .drop-forbidden {
    background-color: rgba(255, 0, 0, 0.2);
  }

  .drop-in {
    box-shadow: 0 0 5px rgba(0, 0, 255, 0.4);
  }

  .list-enter,
  .list-leave-to {
    opacity: 0;
  }

  .list-leave-active {
    position: absolute;
  }

  .part-content-field {
    padding: 10px 10px 10px 10px;
  }

  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }

  .btn {
    width: 100%;
  }

  .part .card .card-header .btn {
    color: #fff;
    background-color: #00BEFF;
    border-color: #00BEFF;
  }

  .b-form-spinbutton .btn {
    width: 100%;
    padding : 0 !important;
    height: 100%;
  }

  .tool-button {
    width: 30%;
    margin: 0px 0px 0px 0px;
  }

  .toggle-controls {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    right: 0;
    /* top: 210px; */
  }

  #toggle-left-components a {
    position: absolute;
    transition: 0.3s;
    padding: 15px;
    width: 120px;
    text-decoration: none;
    color: white;
    z-index: 10;

    left: -70px;
    border-radius: 5px 5px 5px 5px;

    transform: rotate(-90deg);
    /* Legacy vendor prefixes that you probably don't need... */
    /* Safari */
    -webkit-transform: rotate(-90deg);
    /* Firefox */
    -moz-transform: rotate(-90deg);
    /* IE */
    -ms-transform: rotate(-90deg);
    /* Opera */
    -o-transform: rotate(-90deg);
    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }

  #toggle-left-components a:hover {
      left: -30px;
  }

  #toggle-right-config a {
    position: absolute;
    transition: 0.3s;
    padding: 15px;
    width: 120px;
    text-decoration: none;
    color: white;
    z-index: 10;

    right: -70px;
    border-radius: 5px 5px 5px 5px;

    transform: rotate(-270deg);
    /* Legacy vendor prefixes that you probably don't need... */
    /* Safari */
    -webkit-transform: rotate(-270deg);
    /* Firefox */
    -moz-transform: rotate(-270deg);
    /* IE */
    -ms-transform: rotate(-270deg);
    /* Opera */
    -o-transform: rotate(-270deg);
    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }

  #toggle-right-config a:hover {
      right: -30px;
  }

  #about {
      top: 20px;
      background-color: #00BEFF;
  }

  .toggle-content {
    padding: 0;
    position: relative;
    top: 10px !important;
  }

  #start-guide {
    color: white;
    background-color: rgb(178,180,183);
    border-color: rgb(178,180,183);
    width: 100%;
  }

  #start-guide:hover {
    background-color: rgb(178,180,183);
    color: #323232;
    border-color: rgb(178,180,183);
  }

  #drag-components-here {
    min-width: 393px;
  }

  .v-tour__target--highlighted {
    box-shadow: 0 0 0 99999px rgba(0, 0, 0, .4);
  }

  #iframe-div {
    margin-top: 0.5rem;
  }

  #iframe-div > iframe {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) calc(0.25rem - 1px) calc(0.25rem - 1px);
    border: 3px solid #6c757d;
  }

  @media (max-width: 799px) {
    .group {
      flex-direction: row;
      flex-wrap: wrap;
    }

    .select-list {
      width: 100%;
    }

    #drop-components-here {
      width: 100%;
    }
  }

  .validation-result-div pre {
    margin: 0;
  }

  .validation-result-div .valid-false {
    background: rgba(139, 0, 0, 0.2);
  }

  .validation-result-div .valid-false pre {
    color: darkred;
  }

  .validation-result-div .valid-true {
    background: rgba(0, 100, 0, 0.2);
  }

  .validation-result-div .valid-true pre {
    color: darkgreen;
  }

  .tooltip-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  }
</style>
